import { Component, Input } from '@angular/core'

@Component({
  selector: 'lin-card',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        width: 260px;
        height: min-content;
        margin: 24px 0 0 24px;
        padding: 0;
        border-radius: 10px;
        border: 1px solid var(--primary-border-color);
        overflow: hidden;
      }
    `,
  ],
  standalone: false,
})
export class CardComponent {}

@Component({
  selector: 'lin-card-title',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        font-size: 1.7rem;
        font-weight: var(--font-weight-medium);
        letter-spacing: -0.26px;
        padding: 14px 15px;
        margin: 0;
        pointer-events: none;
        text-transform: uppercase;
      }
    `,
  ],
  standalone: false,
})
export class CardTitleComponent {}

@Component({
  selector: 'lin-card-content',
  template: `
    <div class="content">
      <ng-content></ng-content>
      @if (noRouteIcon) {
        <mat-icon svgIcon="keyboard_arrow_right"></mat-icon>
      }
    </div>
  `,
  styles: [
    `
      :host {
        color: var(--secondary-font-color);
        border-top: 1px solid var(--primary-border-color);
        cursor: pointer;
        font-size: 1.5rem;
        font-weight: var(--font-weight-medium);
      }

      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 15px;
      }

      .content:hover {
        filter: brightness(150%);
      }
    `,
  ],
  standalone: false,
})
export class CardContentComponent {
  @Input() noRouteIcon = true
}
